import * as React from 'react';
import { Layout as DashboardLayout } from '@/layouts/v2/layout';
import type { RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

import { paths } from '@/paths';
import { RoleGuard } from '@/components/auth/guards/role-guard';

import { ACCOUNT_ROLES } from '@/constants/account-roles';
import { COMMUNITY_ROLES } from '@/constants/community-roles';
import RequestPageV2 from '@/pages/v2/requests/request';
import RequestsPageV2 from '@/pages/v2/requests';

export const route: RouteObject = {
  path: paths.requests.index,
  element: (
      <DashboardLayout>
        <Outlet />
      </DashboardLayout>
  ),
  children: [
    {
      index: true,
      element: (
        <RoleGuard
          requiredAccountRoles={[
            ACCOUNT_ROLES.ACCOUNT_OWNER,
            ACCOUNT_ROLES.ACCOUNT_ADMIN,
            ACCOUNT_ROLES.ACCOUNT_MANAGER,
          ]}
          requiredCommunityRoles={[COMMUNITY_ROLES.COMMUNITY_MANAGER, COMMUNITY_ROLES.COMMUNITY_MEMBER]}
        >
          <RequestsPageV2 />
        </RoleGuard>
      ),
    },
    {
      path: paths.requests.request(':requestId'),
      element: (
        <RoleGuard
          requiredAccountRoles={[
            ACCOUNT_ROLES.ACCOUNT_OWNER,
            ACCOUNT_ROLES.ACCOUNT_ADMIN,
            ACCOUNT_ROLES.ACCOUNT_MANAGER,
          ]}
          requiredCommunityRoles={[COMMUNITY_ROLES.COMMUNITY_MANAGER, COMMUNITY_ROLES.COMMUNITY_MEMBER]}
        >
          <RequestPageV2 />
        </RoleGuard>
      ),
    },
    
  ],
};
